<template>
  <div>
    <h3 class="title mb-3 green--text">Últimos Reajustes</h3>
    <table>
      <thead>
        <tr>
          <th class="text-xs-left" style="min-width: 100px">Competência</th>
          <th class="text-xs-left" style="min-width: 100px">Percentual</th>
          <th class="text-xs-left" style="width: 220px">Motivação</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in dadosReajuste" :key="item.id">
          <td class="dadosReajusteTd">{{ item.periodo }}</td>
          <td class="dadosReajusteTd">{{ item.percentual }}%</td>
          <td class="dadosReajusteTd">{{ item.motivoReajuste }}</td>
        </tr>
        <tr>
          <td colspan="3">
            <div>
              <p v-if="!dadosReajuste.length">Não há dados de reajuste.</p>
              <div v-else>
                <p>
                  * O reajuste é comunicado à ANS em até 30 (trinta) dias após
                  sua aplicação.
                </p>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "Pinss Dados Reajuste",
  props: {
    dadosReajuste: Array
  }
};
</script>

<style scoped lang="scss">
.pinss {
  p {
    margin-bottom: 8px;
  }
}

.dadosReajusteTd {
  width: 100px;
}
</style>
